/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PaymentStateShare Input Action
 */
export class PaymentStateShareInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `payment-state-share`;
    public getCacheObjectType = () => 'payment-state-share';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IPaymentStateShareData {
    isCODSelected: boolean;
    isCreditCardSelected: boolean;
    shouldApplyOnAccountPayment: boolean;
    isStoreSelected: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PaymentStateShareInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: PaymentStateShareInput, ctx: Msdyn365.IActionContext): Promise<IPaymentStateShareData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPaymentStateShareData[]>('/get/example/id/1', 'get');
    return { isCODSelected: true, isCreditCardSelected: false, shouldApplyOnAccountPayment: true, isStoreSelected: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPaymentStateShareData>>action,
    // TODO: Give your data action a unique id
    id: 'PaymentStateShare',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
